import type { PriceTierVolumeDiscountsListResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePriceTierVolumeDiscountsList = (
  priceTierId: number,
  options?: ApiV2QueryOptions<PriceTierVolumeDiscountsListResponseType>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      business?.id,
      ServerStateKeys.PriceTierVolumeDiscounts,
      priceTierId,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `price-tiers/${priceTierId}/volume-discounts`,
      }).then(
        (data) =>
          apiV2AssertResponse<PriceTierVolumeDiscountsListResponseType>(data)
            .data,
      ),
    ...getDefaultQueryOptionsV2({
      user,
      business: business,
      overrideOptions: options,
    }),
    enabled: !!priceTierId && !!business?.id,
  });
};
